import { createContext, RefObject } from "react";
import olMap from "ol/Map";

interface MapContextType {
  map: olMap | null;
  mapRef: RefObject<HTMLDivElement | null>;
}

export const MapContext = createContext<MapContextType | null>(null);
